import React from 'react';
import PropTypes from 'prop-types';

import { StyledMessage } from './CartDiscountMessageStyles';

var CartDiscountMessage = function CartDiscountMessage(_ref) {
  var messageType = _ref.messageType,
      code = _ref.code,
      autoDiscountPromo = _ref.autoDiscountPromo,
      autoDiscountCodeEndDate = _ref.autoDiscountCodeEndDate;

  switch (messageType) {
    case 'SUCCESS':
      if (autoDiscountPromo) {
        return React.createElement(
          StyledMessage,
          null,
          'Promo code ',
          React.createElement(
            'strong',
            null,
            code
          ),
          ' will be applied at checkout if it is valid for the items in your cart. Expires',
          ' ',
          autoDiscountCodeEndDate,
          '.'
        );
      } else {
        return React.createElement(
          StyledMessage,
          null,
          'Promo code ',
          React.createElement(
            'strong',
            null,
            code
          ),
          ' will be applied at checkout if it is valid for the items in your cart.'
        );
      }
    case 'ERROR':
      return React.createElement(
        StyledMessage,
        { messageType: messageType },
        React.createElement(
          'strong',
          null,
          code
        ),
        ' is not valid, please try another code.'
      );
    case 'SHIPPING_CODE':
      return React.createElement(
        StyledMessage,
        null,
        'Promo code ',
        React.createElement(
          'strong',
          null,
          code
        ),
        ' will be applied at checkout if it is valid for the items in your cart.'
      );
    default:
      return null;
  }
};

CartDiscountMessage.propTypes = {
  code: PropTypes.string.isRequired,
  messageType: PropTypes.oneOf(['SUCCESS', 'ERROR', 'SHIPPING_CODE']),
  autoDiscountCodeEndDate: PropTypes.string,
  autoDiscountPromo: PropTypes.bool
};

export default CartDiscountMessage;